"use client";
import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from "react";

const SearchContext = createContext<{
  isSearchOpen: boolean;
  setSearchOpen: React.Dispatch<React.SetStateAction<boolean>>;
}>({ isSearchOpen: false, setSearchOpen: () => {} });

export const useSearch = () => useContext(SearchContext);

export function useIsApple() {
  const [isApple, setIsApple] = useState<boolean>();
  const nav = typeof navigator;
  useEffect(() => {
    if (typeof navigator === "undefined") return;
    const appleAgents = ["Mac", "iPhone", "iPad", "iPod", "Pike"];
    const { userAgentData } = navigator as Navigator & { userAgentData?: { platform: string } };
    if (userAgentData)
      return setIsApple(appleAgents.some((v) => new RegExp("^" + v, "i").test(userAgentData.platform)));
    else return setIsApple(appleAgents.some((v) => new RegExp(v, "i").test(navigator.userAgent)));
  }, [nav]);
  return isApple;
}

export function SearchProvider({ children }: PropsWithChildren) {
  const [isSearchOpen, setSearchOpen] = useState(false);
  const isApple = useIsApple();
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === "k" && (isApple ? e.metaKey : e.ctrlKey)) {
        e.preventDefault();
        setSearchOpen((prev) => !prev);
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => void window.removeEventListener("keydown", handleKeyDown);
  }, [isApple]); //eslint-disable-line react-hooks/exhaustive-deps

  return <SearchContext.Provider value={{ isSearchOpen, setSearchOpen }}>{children}</SearchContext.Provider>;
}
